<div class="container m-t-alt" *ngIf="selectedTabItem && expertGroupPortal">
  <div class="columns">
    <div class="column is-12">
      <h2 class="title is-2">Resources</h2>
      <div class="mb-5">
        <a [routerLink]="[expertGroupPortal.baseUrl, 'publications']" [ngClass]="{
            'is-outlined': selectedTabItem !== 'publications'
          }" class="button is-link ml-0 mr-4 mb-4">Publications</a>
        <a *ngIf="hasMeetings" [routerLink]="[expertGroupPortal.baseUrl, 'meeting-summaries']" [ngClass]="{
            'is-outlined': selectedTabItem !== 'meeting-summaries'
          }" class="button is-link ml-0 mr-4 mb-4">Meeting Summaries
        </a>
        <a *ngIf="hasVideos" [routerLink]="[expertGroupPortal.baseUrl, 'videos']" [ngClass]="{
            'is-outlined': selectedTabItem !== 'videos'
          }" class="button is-link ml-0 mr-4 mb-4">Videos</a>
        <a *ngIf="hasExternalResources" [routerLink]="[expertGroupPortal.baseUrl, 'external-resources']" [ngClass]="{
            'is-outlined': selectedTabItem !== 'external-resources'
          }" class="button is-link ml-0 mr-4 mb-4">External resources</a>
        <a *ngIf="hasPosts" [routerLink]="[expertGroupPortal.baseUrl, 'blog-posts']" [ngClass]="{
            'is-outlined': selectedTabItem !== 'posts'
          }" class="button is-link ml-0 mr-4 mb-4">Posts</a>
      </div>
    </div>
  </div>
</div>
